import './DriftWarning.scss';

import { IconAlertWarningSolid } from '@hulu-react-style-components/icons';
import React from 'react';

import bem from '../../../../utils/bem';

const [block, element] = bem('custom-filter-drift-warning');

const DEFAULT_MESSAGE = 'Filters have been added, removed, or changed and no longer match this saved Custom Filter.';

const DriftWarning = ({ message = DEFAULT_MESSAGE }: { message?: string }): JSX.Element => (
  <div className={block()} data-testid="custom-filter-drift-warning">
    <IconAlertWarningSolid className={element('icon')} width="14px" height="14px" />
    <span>{message}</span>
  </div>
);

export default DriftWarning;
